import React from 'react';
import ReactDOM from 'react-dom/client';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const firebaseConfig = {
  apiKey: "AIzaSyAXv7ic0sNHCfSIHurckIR6DXrVrYIAOXE",
  authDomain: "iuta-website.firebaseapp.com",
  projectId: "iuta-website",
  storageBucket: "iuta-website.firebasestorage.app",
  messagingSenderId: "749730809202",
  appId: "1:749730809202:web:167764d264cbd676c009eb",
  measurementId: "G-JMN6VFERPR"
};

const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
